const LINE_CLASS = 'h-1 grow bg-black-10 dark:bg-black-60';

export const Separator: React.FunctionComponent = () => {
  return (
    <div className="my-24 flex items-center md:my-32">
      <div className={LINE_CLASS} />

      <div className="px-10 text-small-r text-share-text-2">or</div>

      <div className={LINE_CLASS} />
    </div>
  );
};
